var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-request-btn-container",class:{ 'express-checkout-collapsed': !_vm.canMakePayment },attrs:{"id":"express-checkout-element"}})
}
var staticRenderFns = []

export { render, staticRenderFns }